// SHARE — 공유 URL·설명 조립(순수 함수, RULES#143). ShareDock 이 쓴다.
//
// 복사 = 순수 URL(UTM 없음 · Q-S1). 카카오/네이티브 = UTM. 착지 canonical 은 원본 그대로(UTM 은 쿼리일 뿐 — 기존 canonical 체계 불변).
// 설명 120자 절단은 text-safe 경유(서로게이트 반토막 전례).

import { safeSlice } from '@/lib/text-safe';

export type ShareSurface = 'apt' | 'blog' | 'board' | 'stock' | 'daily';

const DEFAULT_DESC = '카더라에서 확인하세요';

/** 원본 URL 에서 쿼리·해시를 떼어 «깨끗한 주소» 로. 못 읽으면 입력 그대로. */
export function cleanUrl(url: string): string {
  try {
    const u = new URL(url);
    u.search = ''; u.hash = '';
    return u.toString();
  } catch { return url; }
}

export function buildShareUrls(url: string, surface: ShareSurface): { copy: string; kakao: string; native: string } {
  const base = cleanUrl(url);
  const q = (medium: string) => `${base}?utm_source=share&utm_medium=${medium}&utm_campaign=${surface}`;
  return { copy: base, kakao: q('kakao'), native: q('native') };
}

export function shareDescription(d: string | null | undefined): string {
  const t = (d ?? '').replace(/\s+/g, ' ').trim();
  return t ? safeSlice(t, 120) : DEFAULT_DESC;
}
